// extracted by mini-css-extract-plugin
export default {"currencyInput":"_0aYKV0G1--CurrencyInput_currencyInput__y6HFD","wiggle":"_0aYKV0G1--CurrencyInput_wiggle__g1kuL","shimmer":"_0aYKV0G1--CurrencyInput_shimmer__8lS--"};